import React from "react";
import styles from "components/BlurOverlay/BlurOverlay.module.css";
import MotionDiv from "../Animate/MotionDiv";

const BlurOverlay = ({
	onClick,
	style,
}: {
	onClick?: () => void;
	style?: React.CSSProperties;
}) => {
	return (
		<MotionDiv
			defaultClassName={styles["overlay"]}
			inStyles={{ opacity: 1 }}
			defaultStyles={{ ...style, opacity: 0 }}
			outStyles={{ opacity: 0 }}
			onClick={onClick}
			data-cy-id="blur-overlay"
		></MotionDiv>
	);
};

export default BlurOverlay;
